import { t } from "@/i18n-js/instance";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";
import { SkeletonLoader } from "@circle-react-shared/uikit/SkeletonLoader";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const TotalDueLine = () => {
  const { previewMutation } = usePaywallCheckoutContext();
  const preview = previewMutation.data;

  return (
    <>
      <Typography.LabelMd weight="semibold">
        {t("paywall_checkout.amount_due")}
      </Typography.LabelMd>
      {!preview || previewMutation.isLoading ? (
        <div className="flex flex-row items-center gap-x-1.5">
          <SkeletonLoader variant="row" lg />
        </div>
      ) : (
        <div className="flex flex-row gap-x-1.5">
          {preview?.first_payment?.discount < 0 && (
            <Typography.LabelMd weight="semibold" color="text-disabled">
              <span className="line-through">
                {formatPaywallCurrencyAmount(
                  preview.currency,
                  preview.first_payment.price_amount,
                  { includeCurrencyCode: false },
                )}
              </span>
            </Typography.LabelMd>
          )}
          <Typography.LabelMd weight="semibold">
            {preview.formatted_amount_due_now}
          </Typography.LabelMd>
        </div>
      )}
    </>
  );
};
